import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPosition } from "./transactions.t";

export interface ITransactionsState {
    transactions: IPosition[],
    transactionsLoading: boolean,
    transactionsError: string | null,
}

const initialState: ITransactionsState = {
    transactions: [],
    transactionsLoading: false,
    transactionsError: null,
}

const transactionsSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {
        getTransactionsAction(state, action: PayloadAction<any>) {
            state.transactionsLoading = true;
        },
        getTransactionsSuccess(state, action: PayloadAction<any>) {
            state.transactionsLoading = false;
            state.transactions = action.payload;
        },
        getTransactionsFailure(state, action: PayloadAction<any>) {
            state.transactionsLoading = false;
            state.transactionsError = action.payload;
        },
    },
});

export const {
    getTransactionsAction,
    getTransactionsSuccess,
    getTransactionsFailure,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;
